/**
 * Generates a consistent color for an avatar based on a string (usually name)
 * @param {string} str - The string to generate color from (typically user name)
 * @returns {string} - A hex color code
 */
export const getAvatarColor = (str) => {
  if (!str) return "#1976d2"; // Default blue if no string provided

  // Simple hash function
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash; // Convert to 32-bit integer
  }

  // Generate HSL color with good saturation and lightness for readability
  const hue = Math.abs(hash % 360); // 0-360 degrees
  const saturation = 65; // 65% - vibrant but not overwhelming
  const lightness = 50; // 50% - balanced brightness

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};
